import { FilterDef } from "@/stores/filters/FilterDef";

export class ActivityFilterDef extends FilterDef {

	constructor() {
		super([
			'keywords',
		]);
	}

}
